import ImageBasic from "../Common/Image/ImageBasic";
import IMG from "../../constants/image";
import {ENV} from "../../network/config";
import {Link, useLocation} from "react-router-dom";
import {useMemo} from "react";
import {PATH} from "../../constants";
import appStore from "../../store/appStore";
import {clsx} from "clsx";

export default function HeaderLogin() {
    const location = useLocation();
    const pathname = location.pathname;
    const {fromNativeApp} = appStore();
    const title = useMemo(() => {
        if (pathname === PATH.ONBOARDING) return 'Nhà bán hàng'
        return 'Đăng ký làm nhà bán hàng'
    }, [pathname])
    return (
        <div
            className={clsx("relative z-10 flex justify-between px-4 py-3 space-x-4 w-full",
                fromNativeApp ? 'h-[110px] items-end' : 'h-[80px] items-center')}>
            <Link to={ENV.FUNONG_DOMAIN} className="flex items-center space-x-4" aria-label="Home">
                <ImageBasic
                    src={IMG.logoLight}
                    alt="Picture of the author"
                    className="w-[109px] h-[35px] rounded-[18px]"
                />
            </Link>
            <div className="text-xs text-white">
                {title}
            </div>
        </div>
    )
}
